module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/vendor/my-settings-v/change-password-v/change-password-v.component.scss
// module id = ./src/app/pages/vendor/my-settings-v/change-password-v/change-password-v.component.scss
// module chunks = main